import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  getData (context) {
    let path = 'privilege'
    Vue.axios.get(path)
      .then(response => {
        for (let index = 0; index < response.data.length; index++) {
          addPrivilegeIdsField(response.data[index])
        }

        context.commit('SET_PRIVILEGELIST', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  /**
   * @param context
   */
  async getPrivileges (context) {
    let privilegeList = await Vue.axios.get('privilege')
      .then(response => {
        return JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    return privilegeList
  },

  setSelectedRole (context, roleSelected) {
    context.commit('SET_SELECTEDROLE', roleSelected)
  },

  addPrivilegesSelectedLeft (context, privileges) {
    context.commit('SET_PRIVILEGES_SELECTED_LEFT', privileges)
  },

  addPrivilegesSelectedRight (context, privileges) {
    context.commit('SET_PRIVILEGES_SELECTED_RIGHT', privileges)
  },

  async getPrivilegeData (context, params) {
    let path = 'privilege/' + params.data.privilegeId
    let populate = []
    let requestParam

    if (params.options && params.options.populate && !params.options.populate) {
      populate = []
      requestParam = { params: { populate: populate.join(',') } }
    }

    let privilege = await Vue.axios.get(path, requestParam)
      .then(response => {
        addPrivilegeIdsField(response.data)

        context.commit('UPDATE_PRIVILEGE_IN_PRIVILEGELIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    return privilege
  },

  async createPrivilegeData (context, params) {
    let response
    params.data.Roles = params.data.RoleIds

    delete params.data.id
    await Vue.axios.post('privilege', params.data)
      .then(response => {
        addPrivilegeIdsField(response.data)

        context.commit('ADD_PRIVILEGE_TO_PRIVILEGELIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
      })

    return response
  },

  async updatePrivilegeData (context, params) {
    let response
    params.data.Roles = params.data.RoleIds

    await Vue.axios.patch('privilege/' + params.data.id, params.data)
      .then(response => {
        addPrivilegeIdsField(response.data)

        context.commit('UPDATE_PRIVILEGE_IN_PRIVILEGELIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
      })

    return response
  }
}

let addPrivilegeIdsField = function (privilegeData) {
  privilegeData.RoleIds = privilegeData.Roles.map(item => item.id)
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/privilege/privilege.actions.js
// module id = null
// module chunks = 